import { lazy } from 'react';

const TermsAndPrivacy = lazy(() => import('./TermsAndPrivacy'));

const TermsAndPrivacyConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: 'privacy',
      element: <TermsAndPrivacy />,
    },
  ],
};

export default TermsAndPrivacyConfig;
